import { Component, Input } from '@angular/core';

export interface SectionTimeline {
  description: string;
  data: Array<{
    title: string;
    year: string;
    description: string;
  }>;
}

@Component({
  selector: 'fcp-section-timeline',
  templateUrl: './section-timeline.component.html',
  styleUrls: ['./section-timeline.component.scss']
})
export class SectionTimelineComponent {
  public fullTimeLine: any;
  public filteredTimeLine: any;

  @Input() public set timeline(value: Array<any>) {
    const timeline = value ? value : [];
    this.fullTimeLine = this.createNewReference(timeline);
    this.filteredTimeLine = this.filterAndSort(this.createNewReference(value));
  }

  public get getTabs(): Array<any> {
    return this.filteredTimeLine;
  }

  public showMore(): void {
    this.filteredTimeLine = this.createNewReference(this.fullTimeLine);
  }

  private filterAndSort(value): Array<any> {
    value.data = value.data
      .filter((event, index) => index < 10)
      .sort((a, b) => parseInt(a.year) > parseInt(b.year) ? 1 : -1);
    return value;
  }

  private createNewReference(value) {
    return JSON.parse(JSON.stringify(value));
  }
}
